module.exports = __webpack_public_path__ + "img/c.26603f18.png";